import React, { Component } from "react";
import InputText from "../blueprintWrappers/InputText";
import TaskStatusSelector from "./TaskStatusSelector";
import { Button } from "@blueprintjs/core";
import { TASK_STATUS_OPTIONS, TASK_STATUS, TASK_STATUS_COLOR } from "./constants";
import { connect } from 'react-redux';
import { actions } from '../../config/reduxIndex';
import CalendarInputWithButton from "../blueprintWrappers/CalendarInputWithButton";
import SelectWrapper from "../blueprintWrappers/SelectWrapper";
import { optionFactory } from "../shared/optionFactory";

export const PM_OVERLAY_HIDDEN_FIELDS = {
	bp: [
		'key',
		'parentID',
		'bp',
		'phase',
		'project',
		'uniqueID',
		'assigned',
		'additionalDetails'
	],
	contacts: [
		'uniqueID',
		'name',
		'active'
	],
	'contacts-edit': [
		'name',
		'uniqueID',
		'label',
		'parentID',
		'phone2',
		'active'
	],
	project: [
		'key',
		'parentID',
		'uniqueID',
		'bp',
		'phase',
		'phases',
		'assigned',
		'attachments',
		'additionalDetails'
	],
	phase: [
		'key',
		'parentID',
		'uniqueID',
		'bp',
		'project',
		'taskGroups',
		'assigned',
		'attachments',
		'additionalDetails',
		'contacts'
	],
	taskgroup: [
		'key',
		'parentID',
		'uniqueID',
		'bp',
		'project',
		'phase',
		'tasks',
		'assigned',
		'additionalDetails',
		'hourLines'
	],
	'taskgroup-edit': [
		'key',
		'parentID',
		'uniqueID',
		'bp',
		'project',
		'phase',
		'tasks',
		'assigned',
		'additionalDetails',
		'hourLines'
	],
	task: [
		'key',
		'phaseID',
		'parentID',
		'uniqueID',
		'bp',
		'project',
		'phase',
		'tasks',
		'assigned'
	],
	'task-edit': [
		'key',
		'phaseID',
		'parentID',
		'uniqueID',
		'bp',
		'project',
		'phase',
		'tasks',
		'assigned'
	]
}

class PMOverlay extends Component {

	state = {
		fields: null,
		saved: true,
	}

	componentWillMount() {
		this.retrieveAndFilter();
	}

	componentDidUpdate(prevProps) {
		if (prevProps !== this.props) {
			this.retrieveAndFilter();
		}
	}

	retrieveAndFilter = () => {
		let cur = this.props.reduxData.temp;
		this.setState({
			fields: Object.entries(cur),
			currentItem: cur,
		})
	}

	render() {

		return (
			<div className="bp__edit sales_lines_popover pt-card" >
				<div className="subpage_wrapper" >

					{this.buttons()}

					<div className={"TaskLineBreak"}></div>

					{this.renderFields()}
				</div>
			</div>
		)
	}

	createReturnObj = (attr) => {
		return { attr };
	}

	statusOptions = () => {
		const opts = TASK_STATUS_OPTIONS
		return optionFactory(opts);
	}

	renderFields() {
		let filtered = this.state.fields.filter(this.isNotHiddenField)
		return filtered.map((field, i) => {
			return this.createFields(field, i);
		});
	}

	createFields = (field, i) => {
		const { index } = this.props;
		const { currentItem } = this.state;
		let statusProps = {
			onChange: this.onChange,
			value: currentItem.status,
			returnObj: this.createReturnObj('status')
		}

		switch (field[0]) {
			case 'status':
				return <div key={field[0] + '_' + i}>
					<h3 className={"OverlayFieldCapitalize"}>Status</h3>
					<SelectWrapper
						{...statusProps}
					>
						{this.statusOptions()}
					</SelectWrapper>
				</div>

			/* TODO color return <div key={field[0] + '_div_' + i}>
					<h3>{field[0]}</h3>
					<TaskStatusSelector
						options={TASK_STATUS}
						colors={TASK_STATUS_COLOR}
						field={field}
						onClick={this.onChange}
						index={index}
						key={field[0] + '_k_' + i}
					/>
				</div>*/
			case 'generalNotes':
				let gnprops = {
					onChange: this.onChangeNotes,
					defaultValue: field[1],
					index: i,
					multiline: "true",
					rows: "4",
					cols: "80",
					attr: field[0],
				}
				return (

					<div key={field[0] + '_' + i}>
						<h3 className={"OverlayFieldCapitalize"}>{field[0]}</h3>
						<textarea
							{...gnprops}

						/>
					</div>
				)
			case 'devNotes':
				let dnprops = {
					onChange: this.onChangeNotes,
					defaultValue: field[1],
					index: i,
					multiline: "true",
					rows: "4",
					cols: "80",
					attr: field[0],
				}
				return (

					<div key={field[0] + '_' + i}>
						<h3 className={"OverlayFieldCapitalize"}>{field[0]}</h3>
						<textarea
							{...dnprops}

						/>
					</div>
				)
			case 'dueDate':
				return (
					<div key={field[0] + '_' + i}>
						<h3 className={"OverlayFieldCapitalize"}>{field[0]}</h3>
						<CalendarInputWithButton
							value={field[1]}
							onChange={this.onChange}
							returnObj={{ attr: 'dueDate' }}
						/>
					</div>
				)
			default:
				let props = {
					onChange: this.onChange,
					index: i,
					value: field[1],
					returnObj: { attr: field[0], index: index }
				}
				return (

					<div key={field[0] + '_' + i}>
						<h3 className={"OverlayFieldCapitalize"}>{field[0]}</h3>
						<InputText
							{...props}
						/>
					</div>
				)
		}
	}

	onChange = (value, obj) => {
		const p = this.props;
		let newCurrent = p.reduxData.temp;
		newCurrent[obj.attr] = value;
		p.setAttributeByObj({
			temp: newCurrent
		});

		this.setState({
			saved: false
		})
	}

	onChangeNotes = (e) => {
		const p = this.props;
		const attr = e.target.getAttribute('attr');
		let newTemp = p.reduxData.temp;
		newTemp[attr] = e.target.value;

		p.setAttributeByObj({
			temp: newTemp
		});

		this.setState(function () {
			return {
				saved: false,
			}
		});
	}

	isNotHiddenField = (field) => {
		let hiddenFields = PM_OVERLAY_HIDDEN_FIELDS[this.props.reduxData.overlayEditType];
		let result = true;
		hiddenFields.forEach(h => {
			if (h === field[0]) {
				result = false;
			}
		});
		return result;
	}

	buttons = () => {
		const p = this.props;
		const btnStyle = { // TODOCSS
			'marginTop': '0px',
			'paddingTop': '24px',
			'textAlign': 'center',
			'marginBottom': '24px',
		}

		return <div className="projectmanager_button_row" style={btnStyle}>
			<Button
				large
				icon="pin"
				title="Save"
				intent="primary"
				onClick={this.onSave}
			>
				Save
			</Button>

			<Button
				large
				icon="pin"
				title="Cancel"
				intent="primary"
				onClick={this.onCancel}
			>
				Cancel
			</Button>
		</div>
	}

	onSave = () => {
		const p = this.props;
		this.setState({
			saved: true
		})

		switch (p.reduxData.overlayEditType) {
			case 'project':
				p.addProject(p.reduxData.temp);
				break;
			case 'phase':
				p.addPhase(p.reduxData.temp);
				break;
			case 'taskgroup':
				p.addTaskGroup(p.reduxData.temp);
				break;
			case 'taskgroup-edit':
				p.updateTaskGroup(p.reduxData.temp);
				break;
			case 'contacts':
				p.saveBPContact(p.reduxData.temp);
				break;
			case 'contacts-edit':
				p.saveBPContact(p.reduxData.temp);
				break;
			default:
				console.log("no overlayEditType set");
		}

		p.closeOverlay();
	}

	onCancel = () => {
		const p = this.props;
		p.setAttributeByObj({
			temp: null
		});
		p.closeOverlay();
	}
}

function mapStateToProps(state) {
	return {
		reduxData: state.pmData
	}
}

const mapDispatchToProps = dispatch => {
	return {
		setAttributeByObj: (obj) => {
			dispatch(actions.pm.setAttributeByObj(obj));
		},
		setRoute: (route) => {
			dispatch(actions.routing.setRoute(route));
		},
		addProject: (obj) => {
			dispatch(actions.pm.addProject(obj)),
				dispatch(actions.pm.saveNewProject(obj))
		},
		addPhase: (obj) => {
			dispatch(actions.pm.addPhase(obj)),
				dispatch(actions.pm.savePhase(obj))
		},
		addTaskGroup: (obj) => {
			dispatch(actions.pm.addTaskGroup(obj))
		},
		saveBPContact: (obj) => {
			dispatch(actions.pm.saveBPContact(obj))
		},
		updateBP: (obj) => {
			dispatch(actions.pm.updateBP(obj))
		},
		updateTaskGroup: (obj) => {
			dispatch(actions.pm.updateTaskGroup(obj))
		},
		closeOverlay: () => {
			dispatch(actions.globalState.closeOverlay());
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(PMOverlay);


// WEBPACK FOOTER //
// ./src/components/projectmanager/PMOverlay.js